module.exports = function () {
    if ( document.querySelector(".header") ) {
        const header = document.querySelector(".header");
        const mobileMenu = header.querySelector(".mobile-menu");
        let mobile = 1280
        
        const menuItemHasChildren = header.querySelectorAll(".menu-item-has-children > a");
        
        menuItemHasChildren.forEach(menuItem => {
            const subMenu = menuItem.parentNode.querySelector(".sub-menu");
            
            // set sub menu width
            const items = [...subMenu.querySelectorAll(".menu-item")];
            if ( !items.some(item => item.textContent.length > 15 ) ) {
                subMenu.style.minWidth = "246px";
            }
            
            const addMenuItemClone = () => {
                if ( !menuItem.getAttribute("href").includes("#") && !subMenu.querySelector('.menu-item-clone') ) {
                    const newItemMenu = document.createElement('li');
                    newItemMenu.classList.add("menu-item", "menu-item-clone");
                    newItemMenu.innerHTML = '<a href="' + menuItem.getAttribute("href") + '">All</a>';

                    subMenu.insertBefore(newItemMenu, subMenu.firstChild);
                }
            }
            
            menuItem.addEventListener("mouseenter", (e) => {
                if ( window.innerWidth >= mobile ) {
                    e.target.parentNode.classList.add("active");
                    e.target.parentNode.classList.add("active-hover");
                }
            })
            
            menuItem.parentNode.addEventListener("mouseleave", (e) => {
                e.target.classList.remove("active");
                e.target.classList.remove("active-hover");
                subMenu.style.maxHeight = null;
                
                // remove menu item clone
                if ( subMenu.querySelector(".menu-item-clone") ) {
                    subMenu.removeChild(subMenu.querySelector(".menu-item-clone"));
                }
            })
            
            menuItem.addEventListener("click", (e) => {
                if ( e.pointerType === "touch" || window.innerWidth < mobile ) {
                    e.preventDefault();
                    
                    if ( !e.target.parentNode.classList.contains("active") || e.target.parentNode.classList.contains("active-hover") ) {
                        addMenuItemClone();
                        subMenu.style.maxHeight = null;

                        subMenu.style.maxHeight = `${subMenu.scrollHeight + 40}px`
                        e.target.parentNode.classList.add("active");
                    }
                    else {
                        subMenu.style.maxHeight = null;
                        e.target.parentNode.classList.remove("active");
                    }
                }
            })
        })
        
        // open menu in mobile
        const ham = header.querySelector(".header__ham");
        let isOpen = false;
        
        if ( ham ) {
            ham.addEventListener("click", () => {
                if ( isOpen ) {
                    closeMenu();
                }
                else {
                    openMenu();
                }
            })
        }
        
        // close menu on desktop
        window.addEventListener("resize", () => {
            if ( window.innerWidth >= mobile ) {
                closeMenu();
                closeMenuBottom();
            }
        })
        
        function openMenu() {
            if ( mobileMenu ) {
                closeMenuBottom();
                closeSearch();

                header?.classList.add("opened");
                ham?.classList.add("active");
                document.body.classList.add("overflow-hidden");
                const menuHeight = `calc(100vh - ${mobileMenu.getBoundingClientRect().top}px)`;
                mobileMenu.style.height = menuHeight;
                mobileMenu.style.maxHeight = menuHeight;
                isOpen = true;
            }
        }
        
        function closeMenu() {
            if ( mobileMenu ) {
                ham.classList.remove("active");
                document.body.classList.remove("overflow-hidden");
                mobileMenu.style.maxHeight = null;
                isOpen = false;
            }
        }
        
        // open bottom menu in mobile
        const headerBottomBtn = document.querySelector(".header__bottom__btn");
        const headerBottom = document.querySelector(".header__bottom");
        const headerBottomMenu = document.querySelector(".header__bottom-menu");
        let isOpenMenuBottom = false;
        
        function openMenuBottom() {
            if ( headerBottom ) {
                closeMenu();
                closeSearch();

                const menuHeight = `calc(100vh - ${headerBottomMenu.getBoundingClientRect().top}px)`;
                headerBottomBtn.classList.add("scale-[-1]");
                document.body.classList.add("overflow-hidden");
                headerBottomMenu.style.height = menuHeight;
                headerBottomMenu.style.maxHeight = menuHeight;
                headerBottom.classList.add("open");
                isOpenMenuBottom = true;
            }
        }
        
        function closeMenuBottom() {
            if ( headerBottom ) {
                headerBottomBtn.classList.remove("scale-[-1]");
                document.body.classList.remove("overflow-hidden");
                headerBottomMenu.style.maxHeight = null;
                headerBottom.classList.remove("open");
                isOpenMenuBottom = false;
            }
        }
        
        if ( headerBottomBtn ) {
            headerBottomBtn.addEventListener("click", () => {
                if ( isOpenMenuBottom ) {
                    closeMenuBottom();
                }
                else {
                    openMenuBottom();
                }
            })
        }
        
        // header search
        const headerSearch = document.querySelector(".header__search");
        let isOpenSearch = false;
        
        function openSearch() {
            if ( headerSearch ) {
                closeMenu();
                closeMenuBottom();

                headerSearch.classList.add("active");

                if ( window.innerWidth < mobile ) {
                    headerSearch.style.top = `${header.querySelector(".header__main").getBoundingClientRect().bottom - headerSearch.clientHeight}px`;
                }
                else {
                    headerSearch.style.top = null;
                }

                header.querySelector(".header__main__open-search__open").classList.add("hidden");
                header.querySelector(".header__main__open-search__close").classList.remove("hidden");
                isOpenSearch = true;
            }
        }

        function closeSearch() {
            if ( headerSearch ) {
                headerSearch.classList.remove("active", "translate-y-full");
                header.querySelector(".header__main__open-search__open").classList.remove("hidden");
                header.querySelector(".header__main__open-search__close").classList.add("hidden");
                isOpenSearch = false;
            }
        }

        function toggleSearch() {
            if ( isOpenSearch) {
                closeSearch();
            }
            else {
                openSearch();
            }
        }
        
        if ( headerSearch ) {
            document.querySelector(".header__main__open-search").addEventListener("click", toggleSearch);
        }
    }
}